import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Alert, CircularProgress } from "@mui/material";
import "../reputation/reputation.css";
import "./welcome.css";
import "./pickupConfirm.css";

function PickupConfirm() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const satisfactionStatus = searchParams.get("s");

  const [loading, setLoading] = useState(true);
  const [confirmationStatus, setConfirmationStatus] = useState("success");
  const [patientInfo] = useState({
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    cellPhone: "(555) 123-4567",
    homePhone: "(555) 987-6543",
    storeLocation: "Main Street Optical",
  });

  useEffect(() => {
    // Placeholder until pickup confirmation API is wired.
    const timer = setTimeout(() => {
      setLoading(false);
      if (satisfactionStatus === "expired") {
        setConfirmationStatus("expired");
      } else if (satisfactionStatus === "error") {
        setConfirmationStatus("error");
      } else {
        setConfirmationStatus("success");
      }
    }, 800);

    return () => clearTimeout(timer);
  }, [satisfactionStatus]);

  if (loading) {
    return (
      <div className="welcome-stack">
        <section className="rep-panel welcome-loading">
          <CircularProgress size={28} />
          <p className="rep-copy" style={{ margin: 0 }}>
            Verifying your confirmation…
          </p>
        </section>
      </div>
    );
  }

  if (confirmationStatus === "error") {
    return (
      <div className="welcome-stack">
        <section className="rep-panel pickup-confirm-status">
          <div className="pickup-confirm-icon pickup-confirm-icon--error" aria-hidden="true">
            <i className="bi bi-exclamation-circle" />
          </div>
          <h2 className="rep-title">Invalid confirmation link</h2>
          <p className="rep-copy" style={{ marginBottom: 0 }}>
            We couldn’t verify your confirmation. The link may be invalid or has
            already been used. Please contact your clinic for help.
          </p>
        </section>
      </div>
    );
  }

  if (confirmationStatus === "expired") {
    return (
      <div className="welcome-stack">
        <section className="rep-panel pickup-confirm-status">
          <div className="pickup-confirm-icon pickup-confirm-icon--warning" aria-hidden="true">
            <i className="bi bi-hourglass-bottom" />
          </div>
          <h2 className="rep-title">Confirmation link expired</h2>
          <p className="rep-copy" style={{ marginBottom: 0 }}>
            This confirmation link has expired. Please contact your clinic to
            request a new link.
          </p>
        </section>
      </div>
    );
  }

  return (
    <div className="welcome-stack">
      <section className="rep-panel">
        <div className="rep-done">
          <div className="rep-done-mark" aria-hidden="true">
            <i className="bi bi-check-lg" />
          </div>
          <h2 className="rep-title">Pickup confirmed</h2>
          <p className="rep-copy" style={{ marginBottom: 0 }}>
            Thank you for confirming your pickup.
          </p>
        </div>
      </section>

      <section className="rep-panel">
        <Alert severity="info" sx={{ mb: 0 }}>
          Please bring a valid photo ID when picking up your glasses or contact
          lenses.
        </Alert>
      </section>

      <section className="rep-panel">
        <h3 className="welcome-section-title">Patient information</h3>
        <p className="welcome-section-copy">
          Details for this pickup confirmation.
        </p>
        <div className="pickup-confirm-details">
          <div className="pickup-confirm-row">
            <span className="pickup-confirm-label">Name</span>
            <span className="pickup-confirm-value">
              {patientInfo.firstName} {patientInfo.lastName}
            </span>
          </div>
          <div className="pickup-confirm-row">
            <span className="pickup-confirm-label">Email</span>
            <span className="pickup-confirm-value">{patientInfo.email}</span>
          </div>
          <div className="pickup-confirm-row">
            <span className="pickup-confirm-label">Cell phone</span>
            <span className="pickup-confirm-value">{patientInfo.cellPhone}</span>
          </div>
          {patientInfo.homePhone && (
            <div className="pickup-confirm-row">
              <span className="pickup-confirm-label">Home phone</span>
              <span className="pickup-confirm-value">{patientInfo.homePhone}</span>
            </div>
          )}
          <div className="pickup-confirm-row">
            <span className="pickup-confirm-label">Location</span>
            <span className="pickup-confirm-value">{patientInfo.storeLocation}</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PickupConfirm;
